/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================React Hooks===================
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// ==================Style&IMG===================
import './style.scss';
import logo from '../../assets/images/eposlogo.png';

// ==================Actions===================
import { setOpenCommandLineClientModal, setOpenSafariModal, setSaveHtmlModal } from '../../actions/header';
// import { setAddToHistory } from '../../actions/menuButton';
import { setOpenTour } from '../../actions/site';

function Header() {
  // ==================Hook===================
  const dispatch = useDispatch();
  const dataHeader = useSelector((state) => state.header.data);

  // ==================JSXconst style===================

  const styleFeedback = {
    backgroundColor: '#EE9900',
  };
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // ==================Handler===================
  function handleOpenCommandLineClientModal(e, param) {
    e.preventDefault();
    dispatch(setSaveHtmlModal(param));
    dispatch(setOpenCommandLineClientModal(true));
  }

  function handleOpenSafariModal() {
    dispatch(setOpenSafariModal(true));
  }
  // function handleOpenHistoryModal() {
  //   dispatch(setOpenHistoryModal(true));
  //   dispatch(setAddToHistory(JSON.parse(localStorage.getItem('allHistory'))));
  // }
  function handleLaunchOpenTour() {
    dispatch(setOpenTour(true));
  }

  // function to create tabe array for create button and drop down menu,
  // and to display in JSX component
  function displayWindowButton() {
    const tabe = [];
    for (let i = 0; i < dataHeader.window_button.length; i += 2) {
      tabe.push(
        <li key={dataHeader.window_button[i].id} id="window--button" className="nav-item"><a className="btn nav-link" onClick={(e) => handleOpenCommandLineClientModal(e, dataHeader.window_button[i + 1].value)}>{dataHeader.window_button[i].value}</a></li>,
      );
    }
    return tabe;
  }
  function displayMenuButton() {
    const tabe = [];
    for (let i = 0; i < dataHeader.menu_button.length; i += 1) {
      for (let y = 0; y < dataHeader.menu_button[i].value.length; y += 1) {
        tabe.push(
          <li key={dataHeader.menu_button[i].value[y].id + dataHeader.menu_button[i].value[y].title} role="presentation" className="dropdown nav-item" id="menu--button">
            <a
              className="btn nav-link dropdown-toggle"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              href=""
            >
              {dataHeader.menu_button[i].value[y].title}
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              {dataHeader.menu_button[i].value[y].list.map((el) => {
                const tabBis = [];
                if (el.value.item === 'Tour of the Interface' && el.type === 'window' && (window.location.hash === '' || window.location.hash === '#/' || window.location.hash.includes('metadata') || window.location.hash.includes('file'))) {
                  tabBis.push(<a key={el.id + el.value.item} className="dropdown-item" onClick={handleLaunchOpenTour}>{el.value.item}</a>);
                }
                else if (el.type === 'link') {
                  if (window.location.pathname.charAt(window.location.pathname.length - 1) === '/') {
                    tabBis.push(<a key={el.id + el.value.item} className="dropdown-item" rel="noreferrer" href={`${window.location.origin}${window.location.pathname}#/${el.value.slug}`} target="_blank">{el.value.item}</a>);
                  }
                  else if (window.location.pathname.charAt(window.location.pathname.length - 1) !== '/') {
                    tabBis.push(<a key={el.id + el.value.item} className="dropdown-item" rel="noreferrer" href={`${window.location.origin}${window.location.pathname}/#/${el.value.slug}`} target="_blank">{el.value.item}</a>);
                  }
                }
                else if (el.type === 'document') {
                  tabBis.push(<a key={el.id + el.value.item} className="dropdown-item" rel="noreferrer" href={el.value.document.file} target="_blank">{el.value.item}</a>);
                }
                return tabBis;
              })}
            </div>
          </li>,
        );
      }
    }
    return tabe;
  }
  function displayLinkButton() {
    const tabe = [];
    for (let i = 0; i < dataHeader.link_button.length; i += 1) {
      for (let y = 0; y < dataHeader.link_button[i].value.length; y += 1) {
        if (dataHeader.link_button[i].value[y].title.toLowerCase().includes('feedback')) {
          tabe.push(
            <li id="link--button" key={dataHeader.link_button[i].id + dataHeader.link_button[i].value[y].title} className="nav-item">
              <a className="btn nav-link" style={styleFeedback} href={dataHeader.link_button[i].value[y].link} target="_blank" rel="noreferrer">
                <img className="btn__img__feedback" src={dataHeader.link_button[i].value[y].image.url} alt="Give Your Feedback" />
                {dataHeader.link_button[i].value[y].title}
              </a>
            </li>,
          );
        }
        else if (dataHeader.link_button[i].value[y].title.toLowerCase().includes('feedback') === false && dataHeader.link_button[i].value[y].title.toLowerCase().includes('epos') === false) {
          tabe.push(
            <li id="link--button" key={dataHeader.link_button[i].id + dataHeader.link_button[i].value[y].title} className="nav-item">
              <a className="btn nav-link" href={dataHeader.link_button[i].value[y].link} target="_blank" rel="noreferrer">
                <img className="btn__img" src={dataHeader.link_button[i].value[y].image.url} alt={`Link to ${dataHeader.link_button[i].value[y].image.title}`} />
                {dataHeader.link_button[i].value[y].title}
              </a>
            </li>,
          );
        }
        else if (dataHeader.link_button[i].value[y].title.toLowerCase().includes('epos')) {
          tabe.push(
            <li id="link--button__epos" key={dataHeader.link_button[i].id + dataHeader.link_button[i].value[y].title} className=" btn__li popup_hover nav-item">
              <a className="btn nav-link" href={dataHeader.link_button[i].value[y].link} target="_blank" rel="noreferrer">
                <img className="btn__img__epos" src={dataHeader.link_button[i].value[y].image.url} alt="Logo_EPOS" />
              </a>
            </li>,
          );
        }
      }
    }
    return tabe;
  }
  return (
    <>
      {/* HEADER */}
      {/* data from API */}
      {(dataHeader.title === 'Header')
        && (
          <header>
            <div id="headband">
              <nav className="navbar navbar-expand-xxl">
                <Link id="headerLink" className="navbar-brand" to="/" target="_blank">
                  <img id="titlelogo" className="d-inline-block align-top" src={dataHeader.logo} alt="Logo" />
                  {dataHeader.header_title}
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                  <ul className="navbar-nav mt-2 mt-lg-0">
                    {(isSafariBrowser)
                      && (
                        <ul className="nav nav-pills">
                          <li> <a className="btn--safari" onClick={handleOpenSafariModal} rel="noreferrer" type="button">Issue with Safari Browsers</a> </li>
                        </ul>
                      )}
                    {
                      /* <li> <a className="btn" onClick={handleOpenHistoryModal}> History </a></li> */
                    }
                    {(dataHeader.menu_button.length > 0) && (
                      displayMenuButton()
                    )}
                    {(dataHeader.window_button.length > 0) && (
                      displayWindowButton()
                    )}
                    {(dataHeader.link_button.length > 0) && (
                      displayLinkButton()
                    )}
                  </ul>
                </div>
              </nav>
            </div>
          </header>
        )}
      {/* display of hard data if no api return  */}
      {(dataHeader.title !== 'Header')
        && (
          <header>
            <div id="headband">
              <div className="logo">
                <Link to="/" target="_blank">
                  <img id="titlelogo" src={logo} alt="Logo" />
                </Link>
              </div>
              <div>
                <ul className="nav nav-pills">
                  <li> <a className="btn" onClick={handleOpenCommandLineClientModal}>Command Line Client</a> </li>
                  {/* <li> <a className="btn" onClick={handleOpenHistoryModal}> History </a></li> */}
                  <li role="presentation" className="dropdown" id="helpid">
                    <a
                      className="btn dropdown-bs-toggle"
                      data-bs-toggle="dropdown"
                      href=""
                      role="button"
                      aria-expanded="false"
                    >
                      Documentation
                    </a>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" onClick={handleLaunchOpenTour}>Tour of the Interface</a></li>
                      {/* <li><Link className="dropdown-item" to="help">User Guides (Videos ans Documents)</Link></li> */}
                      {
                    /* <li>
                      <a className="dropdown-item" href="#/help" target="_blank">
                        User Guides (Videos and Documents)
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#/nodeInfo" target="_blank">
                        EPOS GNSS Node Infrastructure
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="./doc/Quality Assurance Data Gateway.pdf">
                        Quality Assurance
                      </a>
                    </li> */}
                    </ul>
                  </li>
                  <li className="productsid">
                    <a className="btn" href="https://gnssproducts.epos.ubi.pt" target="_blank" rel="noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-window-plus" viewBox="0 0 16 16">
                        <path d="M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
                        <path d="M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z" />
                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z" />
                      </svg> Products portal
                    </a>
                  </li>
                  <li className="productsid popup_hover">
                    <a className="btn" href="https://gnss-metadata.eu/" target="_blank" rel="noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-window-plus" viewBox="0 0 16 16">
                        <path d="M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
                        <path d="M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z" />
                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z" />
                      </svg> M3G
                    </a>
                  </li>
                  <li className="productsid productsid__li popup_hover">
                    <a className="btn" href="https://www.ics-c.epos-eu.org/" target="_blank" rel="noreferrer">
                      <img className="productsid__img" src="https://gnss-metadata.eu/pic/logo_EPOS_ICS.png" alt="Logo_EPOS" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </header>
        )}
    </>
  );
}

export default Header;
